import React, { type FC } from 'react'

import { GRID_VARIANT_SMALL, Grid, GridCell } from 'mailup-web-components'

import InputCritType from 'Pages/RecipientsList/components/filters/InputCritType'

import InputChannel from 'Pages/RecipientsList/components/filters/optout/InputChannel'
import InputOptoutType from 'Pages/RecipientsList/components/filters/optout/InputOptoutType'

import ActionDeleteCriterion from 'Pages/RecipientsList/components/filters/ActionDeleteCriterion'

interface CriterionOptoutTypeProps {
  index: number
}

const CriterionOptoutType: FC<CriterionOptoutTypeProps> = ({ index }) => {
  return (
    <Grid variant={GRID_VARIANT_SMALL} cols={12}>
      <GridCell span={3}>
        <InputCritType index={index} />
      </GridCell>
      <GridCell span={2}>
        <InputChannel index={index} />
      </GridCell>
      <GridCell span={4}>
        <InputOptoutType index={index} />
      </GridCell>
      <GridCell span={1}>
        <ActionDeleteCriterion index={index} />
      </GridCell>
    </Grid>
  )
}

export default CriterionOptoutType
